var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumOfParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6179 12.5842H18.2707V14.5738C18.2707 14.9399 17.9736 15.237 17.6075 15.237H16.2811C15.915 15.237 15.6179 14.9399 15.6179 14.5738V12.5842Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02759 12.5842H3.68038V14.5738C3.68038 14.9399 3.38326 15.237 3.01718 15.237H1.69078C1.3247 15.237 1.02759 14.9399 1.02759 14.5738V12.5842Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68038 5.95239H15.6179C17.0829 5.95239 18.2707 7.14018 18.2707 8.60518V11.9212C18.2707 12.2872 17.9736 12.5844 17.6075 12.5844H1.69078C1.3247 12.5844 1.02759 12.2872 1.02759 11.9212V8.60518C1.02759 7.14018 2.21537 5.95239 3.68038 5.95239Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.618 8.60498C15.9841 8.60498 16.2812 8.90209 16.2812 9.26818C16.2812 9.63426 15.9841 9.93137 15.618 9.93137C15.2519 9.93137 14.9548 9.63426 14.9548 9.26818C14.9548 8.90209 15.2519 8.60498 15.618 8.60498Z",
    fill: "#3C3C3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68053 8.60498C4.04662 8.60498 4.34373 8.90209 4.34373 9.26818C4.34373 9.63426 4.04662 9.93137 3.68053 9.93137C3.31445 9.93137 3.01733 9.63426 3.01733 9.26818C3.01733 8.90209 3.31445 8.60498 3.68053 8.60498Z",
    fill: "#3C3C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80319 0.646729H14.4951C14.7717 0.646729 15.0191 0.818497 15.1159 1.07714L16.9443 5.9523H2.354L4.18244 1.07714C4.27926 0.818497 4.52664 0.646729 4.80319 0.646729Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.364502 3.96265H2.35409V5.28904H0.364502V3.96265Z",
    fill: "#3C3C3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9443 3.96265H18.9339V5.28904H16.9443V3.96265Z",
    fill: "#3C3C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67017 9.26831H13.6285",
    stroke: "#3C3C3C",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumOfParking);
export default __webpack_public_path__ + "static/media/num-of-parking.e757385b789baa19667429f38a6aeafa.svg";
export { ForwardRef as ReactComponent };